export const MAX_UPLOAD_FILE_SIZE_MB = 30;
export const MAX_UPLOAD_FILE_SIZE_BYTES = MAX_UPLOAD_FILE_SIZE_MB * 1024 * 1024;
export const MAX_UPLOAD_FILE_SIZE_LABEL = `${MAX_UPLOAD_FILE_SIZE_MB} MB`;
